<template>
  <div v-if="!isEmpty" v-html="content"></div>
</template>

<script setup>
const props = defineProps({
  content: String
});
const isEmpty = computed(() => !props.content || props.content.includes('(Choose an embed URL)'))
</script>